import { ChevronRightIcon } from "@heroicons/react/24/outline";
import Image from "src/components/elements/Image";
import LeftMenuItemLink from "src/components/navigation/leftNavigation/LeftMenuItemLink";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";

const LeftMenuItemGroupTitle = ({ data, imageClassName, setImageClassName, group_id, page_id, isUnderLine, isSubGroup = false, avoidUnderlineHover = false, setIsSubmenu, isSubmenu, searchTerm, dropdownArrowClass }) => {
  const isActive = (data) => {
    if (!isSubGroup && !isSubmenu && data.submenu.some((item) => `${window.location.origin}${item.link}` === window.location.href)) {
      return data.submenu.some((item) => `${window.location.origin}${item.link}` === window.location.href);
    }

    if (isSubGroup) {
      if (isSubmenu || data?.groupId !== group_id) return false;
      return data.submenu.some((item) => item.slug === page_id);
    } else {
      if (isSubmenu || data?.slug !== group_id) return false;
      return data.slug === page_id || (data.submenu && data.submenu.some((item) => item.slug === page_id)) || data.submenu.some((item) => item.submenu && item.submenu.some((nestedItem) => nestedItem.slug === page_id));
    }
  };

  const shouldShowAsGroup = data.submenu.length > 1 || data.subMenuFilteredDown || data.submenu.some((item) => item.is_group || item.submenu);

  return (
    <>
      {shouldShowAsGroup ? (
        <button
          type="button"
          className={classNames(
            "duration-20 flex h-10 w-full select-none items-center justify-between space-x-1 rounded px-3 text-leftNavTextColor transition-all duration-300 hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor",
            isActive(data) ? "bg-leftNavActiveColor !text-leftNavActiveTextColor" : "",
          )}
          onClick={() => setIsSubmenu(!isSubmenu)}>
          <div className="flex items-center">
            {data.image && (
              <div className={classNames("nav-icon mr-2 h-5 w-5 flex-shrink-0", isSVGString(data.image) ? "" : "flex items-center justify-center", imageClassName)}>
                {isSVGString(data.image) ? (
                  <div
                    className=""
                    dangerouslySetInnerHTML={{ __html: data.image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }}
                  />
                ) : (
                  <Image
                    src={data.image}
                    alt={"Menu image"}
                    classes={imageClassName}
                    onError={() => setImageClassName("hidden")}
                  />
                )}
              </div>
            )}
            <span
              className={classNames(
                "flex w-full items-center text-left font-medium !leading-none",
                data.type === "group" && data.submenu[0].type === "internal" ? "" : !avoidUnderlineHover ? "visited:text-purple-700 group-hover/link:underline" : "",
                isUnderLine && !avoidUnderlineHover ? "group-hover/link:underline" : "",
                isActive(data) ? "text-leftNavActiveTextColor" : "",
              )}>
              {data.name}
            </span>
          </div>
          <ChevronRightIcon className={classNames("transition-rotate h-6 w-6 rounded-md stroke-2 p-1 duration-200", dropdownArrowClass, isSubmenu ? "rotate-90" : "")} />
        </button>
      ) : (
        <LeftMenuItemLink
          data={data.submenu[0]}
          image={data.submenu[0]?.image || data.image || null}
          group_id={group_id}
          page_id={page_id}
          searchTerm={searchTerm}
          imageClassName={imageClassName}
          setImageClassName={setImageClassName}
        />
      )}
    </>
  );
};

export default LeftMenuItemGroupTitle;
